import { MAX_HTML_PREVIEW_BYTES } from '@littlebird/canvas';

export { MAX_HTML_PREVIEW_BYTES };

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'access_token';
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = 'refresh_token';

export const COMPOSER_MIN_HEIGHT = 98;
export const COMPOSER_TEXTAREA_MIN_HEIGHT = 48;
export const COMPOSER_TEXTAREA_MAX_HEIGHT = Math.min(
  window.innerHeight / 4,
  200
);
export const NEW_CHAT_ID = 'NEW_CHAT';

// Pasted text above this limit becomes a file attachment instead of inline text.
export const LONG_PASTE_THRESHOLD = 3500;
export const MAX_TEXT_PREVIEW_BYTES = 512 * 1024;

export const MAX_PDF_CARD_PREVIEW_BYTES = 2 * 1024 * 1024;
export const MAX_OFFICE_PREVIEW_BYTES = 15 * 1024 * 1024;
export const MAX_TOTAL_ATTACHMENT_MB = 30;
export const MAX_TOTAL_ATTACHMENT_BYTES = MAX_TOTAL_ATTACHMENT_MB * 1024 * 1024;
// TODO: If we need stricter image-only limits later, split this global cap into
// separate per-message limits instead of lowering the overall attachment count
export const MAX_ATTACHMENTS_PER_MESSAGE = 10;
export const DISCORD_URL = 'https://littlebird.ai/discord';
export const SUPPORT_EMAIL = 'support@littlebird.ai';
